"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AtomicFocus = _interopRequireDefault(require("draft-plugins/components/AtomicFocus"));

var _classnames = _interopRequireDefault(require("classnames"));

var _draftJs = require("draft-js");

var _EmbedModalV = _interopRequireDefault(require("rich-text-lib/components/EmbedModalV2"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _embedSrc = require("rich-text-lib/utils/embedSrc");

var _embedDataToHtml = _interopRequireDefault(require("rich-text-lib/utils/embedDataToHtml"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _constants = require("composer-plugins/lib/constants");

var _utils = require("composer-plugins/lib/utils");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIButtonGroup = _interopRequireDefault(require("UIComponents/button/UIButtonGroup"));

var _UIFloatingButtonGroup = _interopRequireDefault(require("UIComponents/button/UIFloatingButtonGroup"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var _embed = require("composer-plugins/lib/embed");

var EMBED_OPTIONS_MENU_CLASSNAME = 'embed-component-options';
var EmbedComponent = (0, _createReactClass.default)({
  displayName: "EmbedComponent",
  propTypes: {
    block: _propTypes.default.object.isRequired,
    blockProps: _propTypes.default.object.isRequired,
    contentState: _propTypes.default.object.isRequired
  },
  contextTypes: {
    getEditorState: _propTypes.default.func,
    getReadOnly: _propTypes.default.func.isRequired,
    onChange: _propTypes.default.func
  },
  getInitialState: function getInitialState() {
    return {
      showEmbedModal: false,
      showActionButtons: false
    };
  },
  componentDidMount: function componentDidMount() {
    var _this$props = this.props,
        block = _this$props.block,
        blockProps = _this$props.blockProps;
    var embedData = this.getEntityData(block.getEntityAt(0));
    var scripts = this.getScripts(embedData);
    scripts.forEach(function (script) {
      var scriptHtml = document.createElement('script');
      var srcAttr = script.attributes.find(function (element) {
        return element.key = 'src';
      });
      scriptHtml.src = srcAttr.value;
      scriptHtml.async = true;
      document.body.appendChild(scriptHtml);
    });
    blockProps.onInsertableLoaded();
    document.body.addEventListener('click', this.handleHideActions);
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
    var getCommentsOnly = nextProps.blockProps.getCommentsOnly;
    var getReadOnly = this.context.getReadOnly;
    return !getReadOnly() && !getCommentsOnly();
  },
  componentWillUnmount: function componentWillUnmount() {
    document.body.removeEventListener('click', this.handleHideActions);
    var block = this.props.block;
    var embedData = this.getEntityData(block.getEntityAt(0));
    var scripts = this.getScripts(embedData);
    scripts.forEach(function (script) {
      var srcAttr = script.attributes.find(function (element) {
        return element.key = 'src';
      });
      var scriptHtml = document.querySelector("script[src=\"" + srcAttr.value + "\"]");
      document.body.removeChild(scriptHtml);
    });
  },
  getEntityData: function getEntityData(entityKey) {
    return this.props.contentState.getEntity(entityKey).getData();
  },
  getScripts: function getScripts(embedData) {
    if (!Array.isArray(embedData)) {
      return [];
    }

    return embedData.filter(function (element) {
      return element.tag === 'script';
    });
  },
  getOriginalUrl: function getOriginalUrl(embedData) {
    if (!embedData) {
      return undefined;
    }

    if (!Array.isArray(embedData)) {
      // legacy format
      return embedData.url || embedData.originalUrl;
    } else if (embedData.length !== 1) {
      return undefined;
    }

    var attributes = embedData[0].attributes;
    var urlAttr = attributes && attributes.find(function (element) {
      return element.key === 'url' || element.key === 'originalUrl';
    });
    return urlAttr ? urlAttr.value : undefined;
  },
  handleEditEmbed: function handleEditEmbed(data) {
    var onInsertEmbedChange = this.props.blockProps.onInsertEmbedChange; // We remove the embed and re-add it again with the new data to be sure that the scripts (if any are added correctly)

    this.handleRemoveEmbed();
    onInsertEmbedChange((0, _embedSrc.getEmbedData)(data));
  },
  handleCloseModal: function handleCloseModal() {
    this.setState({
      showEmbedModal: false
    });
  },
  handleOpenModal: function handleOpenModal() {
    var block = this.props.block;
    var _this$context = this.context,
        getEditorState = _this$context.getEditorState,
        onChange = _this$context.onChange;

    var newSelection = _draftJs.SelectionState.createEmpty(block.getKey());

    onChange(_draftJs.EditorState.forceSelection(getEditorState(), newSelection));
    this.setState({
      showEmbedModal: true
    });
  },
  handleRemoveEmbed: function handleRemoveEmbed() {
    var block = this.props.block;
    var entityKey = block.getEntityAt(0);
    var _this$context2 = this.context,
        getEditorState = _this$context2.getEditorState,
        onChange = _this$context2.onChange;
    onChange((0, _draftHelpers.deleteEntity)(entityKey, getEditorState()));
  },
  handleShowActions: function handleShowActions() {
    this.setState({
      showActionButtons: true
    });
  },
  handleHideActions: function handleHideActions(e) {
    var target = e.toElement || e.relatedTarget;

    if ((0, _utils.targetIsOrContainedByEl)("." + _constants.EMBED_COMPONENT_CLASSNAME, target) || (0, _utils.targetIsOrContainedByEl)("." + EMBED_OPTIONS_MENU_CLASSNAME, target)) {
      return;
    }

    this.setState({
      showActionButtons: false
    });
  },
  renderEmbedModal: function renderEmbedModal(embed, url) {
    var showEmbedModal = this.state.showEmbedModal;

    if (!showEmbedModal) {
      return null;
    }

    return _react.default.createElement(_EmbedModalV.default, {
      embed: url || embed,
      onClose: this.handleCloseModal,
      onSubmit: this.handleEditEmbed
    });
  },
  render: function render() {
    var showActionButtons = this.state.showActionButtons;
    var block = this.props.block;
    var embedData = this.getEntityData(block.getEntityAt(0));
    var embedHtml = (0, _embedDataToHtml.default)(embedData);
    var url = this.getOriginalUrl(embedData);

    if (!embedHtml && !url) {
      return null;
    }

    var needsInlineBlock = (0, _embed.hasEmbedDataWidthAndHeight)(embedData);
    return _react.default.createElement("div", {
      className: _constants.EMBED_COMPONENT_CLASSNAME,
      onClick: function onClick(e) {
        // prevent events from bubbling up and focusing editor
        e.stopPropagation();
      },
      onMouseEnter: this.handleShowActions,
      onMouseLeave: this.handleHideActions
    }, this.renderEmbedModal(embedHtml, url), _react.default.createElement(_UIFloatingButtonGroup.default, {
      buttonGroup: _react.default.createElement(_UIButtonGroup.default, {
        className: EMBED_OPTIONS_MENU_CLASSNAME,
        onMouseLeave: this.handleHideActions
      }, _react.default.createElement(_UIButton.default, {
        onClick: this.handleOpenModal,
        size: "extra-small",
        use: "tertiary"
      }, _react.default.createElement(_UIIcon.default, {
        name: "edit"
      }), _react.default.createElement(_FormattedMessage.default, {
        message: "composer-plugins.embedPlugin.buttons.edit"
      })), _react.default.createElement(_UIButton.default, {
        onClick: this.handleRemoveEmbed,
        size: "extra-small",
        use: "tertiary"
      }, _react.default.createElement(_UIIcon.default, {
        name: "delete"
      }), _react.default.createElement(_FormattedMessage.default, {
        message: "composer-plugins.embedPlugin.buttons.delete"
      }))),
      open: showActionButtons
    }, _react.default.createElement("div", {
      className: (0, _classnames.default)('embed-content', {
        'display-inline-block': needsInlineBlock,
        active: showActionButtons
      }),
      dangerouslySetInnerHTML: {
        __html: (0, _embedDataToHtml.default)(embedData, true)
      }
    })));
  }
});

var _default = (0, _AtomicFocus.default)([_constants.EMBED_COMPONENT_CLASSNAME])(EmbedComponent);

exports.default = _default;
module.exports = exports.default;